module.exports = __webpack_public_path__ + "static/img/bg-en.43376911.webp";